import { APPLICATION_URL } from '@/app-config';

export function buildJetSignTemplateEditorUrl(
  templateId: string,
  fileId: string,
  sessionToken?: string,
  options?: { isPreview?: boolean },
): string | null {
  const appBaseUrl = APPLICATION_URL?.trim();
  if (!appBaseUrl) {
    return null;
  }

  const url = new URL(
    `/template/v3/board/${templateId}/${fileId}/`,
    appBaseUrl,
  );

  if (sessionToken) {
    url.searchParams.set('sessionToken', sessionToken);
  }

  if (options?.isPreview) {
    url.searchParams.set('isPreview', 'true');
  }

  return url.toString();
}
